import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders, HttpBackend } from '@angular/common/http';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: "root"
})
export class ApiService {

  constructor(private http: HttpClient) { }

  get(endpoint, params?) {
    return this.http.get(endpoint, params);
  }

  post(endpoint, body, params?) {
    return this.http.post(endpoint, body, params);
  }

  delete(endpoint, params?) {
    return this.http.delete(endpoint, params);
  }
  getUserDetails() {
    return this.http.get<any>(environment.apiUrlCsV1 + '/user', {})
      .pipe(
        map(res => res || res),
        catchError(error => throwError(error))
      );
  }
  getAllCountries() {
    return this.http.get(environment.apiUrlCsV1 + "/countries").pipe(
      map(res => res || []),
      catchError(error => throwError(error))
    );
  }
}
